// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type OwnerGridFragment = { __typename?: 'OwnerGridDTO', id: number, searchOnPriceGrid: boolean, inventoryOnPriceGrid: boolean, optionOnPriceGrid: boolean, revenueOnPriceGrid: boolean };

export const OwnerGridFragment = gql`
    fragment OwnerGrid on OwnerGridDTO {
  id
  searchOnPriceGrid
  inventoryOnPriceGrid
  optionOnPriceGrid
  revenueOnPriceGrid
}
    `;
/* eslint-enable */